import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMeasurements = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.714 4.172a1 1 0 1 0-1.932-.517l-.855 3.191H4.312a1 1 0 1 0 0 2h2.08l-.73 2.718H2.646a1 1 0 1 0 0 2h2.482l-.718 2.678a1 1 0 0 0 1.932.518l.857-3.196h3.784l-.72 2.69a1 1 0 1 0 1.93.517l.86-3.207h2.625a1 1 0 1 0 0-2h-2.089l.728-2.718h3.039a1 1 0 1 0 0-2h-2.503l.717-2.674a1 1 0 1 0-1.932-.517l-.855 3.191H8.998zM8.462 8.846l-.729 2.718h3.785l.728-2.718z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMeasurements;
